import { NumberInput } from "../../../../../../utils/form";
import { Stack, Typography } from "@mui/material";
import _ from "lodash";
import useIsRecurring from "./hooks/useIsRecurring";

const DisableableText = ({ disabled, children }) => {
  return (
    <Typography color={disabled && "text.disabled"}>
      {children}
    </Typography>
  );
}

const RecurringQuantity = props => {
  const quantity = props.form.watch("recurring.quantity");
  const isRecurring = useIsRecurring(props.form);
  const disabled = !isRecurring;

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <DisableableText disabled={disabled}>por</DisableableText>
      <NumberInput form={props.form} name="recurring.quantity" max={11} label="Durante" disabled={disabled} />
      <DisableableText disabled={disabled}>{quantity == 1 ? "vez" : "veces"}</DisableableText>
    </Stack>
  );
};

export default RecurringQuantity;